import { useEffect } from 'react';

const MQ = '(max-width: 640px)';

function enhance(root) {
  if (!window.matchMedia(MQ).matches) return;
  root.querySelectorAll('table:not([data-rt])').forEach(t => {
    const ths = Array.from(t.querySelectorAll('thead th, thead td'));
    t.setAttribute('data-rt', '1');
    if (ths.length < 3 || t.closest('.rt-keep-table')) {
      const wrap = t.parentElement;
      if (wrap && wrap.scrollWidth > wrap.clientWidth + 4) wrap.classList.add('rt-scroll-hint');
      return;
    }
    const labels = ths.map(th => th.textContent.trim().replace(/\s+/g, ' ').slice(0, 24));
    t.querySelectorAll('tbody tr').forEach(tr => {
      Array.from(tr.children).forEach((td, i) => { if (!td.hasAttribute('data-label')) td.setAttribute('data-label', labels[i] || ''); });
    });
    t.classList.add('rt-cards');
  });
}

// Lot 4 ergonomie : transforme automatiquement les tableaux en cartes empilées sur mobile (sans toucher aux pages)
export function useResponsiveTables(containerSelector = '[data-testid="admin-scroll-container"], [data-testid="employee-shell"], main, body') {
  useEffect(() => {
    const root = document.querySelector(containerSelector) || document.body;
    enhance(root);
    const obs = new MutationObserver(() => { window.requestAnimationFrame(() => enhance(root)); });
    obs.observe(root, { childList: true, subtree: true });
    const onResize = () => { root.querySelectorAll('table[data-rt]').forEach(t => { t.removeAttribute('data-rt'); t.classList.remove('rt-cards'); }); enhance(root); };
    window.addEventListener('resize', onResize);
    return () => { obs.disconnect(); window.removeEventListener('resize', onResize); };
  }, [containerSelector]);
}
